// GJ20241211:
//
// =========================
// AMP Cart Drawer Logic (AJP Custom)
// =========================
// This file contains modifications to the cart drawer (AMP Upsells) to not allow SKUs from product add-ons to be removable or have the quantity changed as they need to only be attached to the main product.
// This is called in theme.liquid. Please do not modify or remove without speaking to Geoff (geoff@alljigsawpuzzles.co.uk).

// =========================
// Constants / selectors
// =========================
var PRODUCT_TYPE_TO_HIDE = "AMP_HIDDEN";

// ===== AJP APO linking constants =====
const CART_LINE_SELECTOR = ".amp-cart__cart-line";
const PROP_KEY_HAS_APO = "_apo_variants";     // parent line property
const PROP_KEY_ADDED_BY = "_apo_added_by";    // child line property

function ampAddClearCartLink () {
  const ampCartLines = document.querySelector('.amp-cart-drawer .amp-cart__cart-lines');
  if (document.querySelector('.amp-clear-cart-link')) return
  if (ampCartLines) {
    const clearElement = document.createElement('p');
    clearElement.classList.add('amp-clear-cart-link');
    clearElement.textContent = 'Clear Basket';
    
    clearElement.addEventListener('click', e => {
      fetch(`${window.Shopify.routes.root}cart/clear.js`, {
        method: 'POST',
      })
        .then(response => response.json())
        .then(data => {
          console.log('AMP UPSELL CART CLEARED');
        })
        .catch(error => {
          console.error('Error clearing amp upsell cart:', error);
        });
    });
    
    ampCartLines.insertAdjacentElement('afterend', clearElement);
  }
}

function ampToggleClearCartLink (count) {
  const ampCartClearLink = document.querySelector('.amp-cart-drawer .amp-clear-cart-link');
  
  if (ampCartClearLink) {
    if (count > 0) {
      ampCartClearLink.style.display = 'block';
    } else {
      ampCartClearLink.style.display = 'none';
    }
  }
}

// =========================
// Helpers
// =========================

function getLineElForItem(item, index) {
  // Prefer a direct lookup by our stamped cart key
  const byKey = document.querySelector(`.amp-cart__cart-line[data-ajp-cart-key="${item.key}"]`);
  if (byKey) return byKey;

  // Fallback (first run, before keys are stamped)
  const byIndex = document.querySelectorAll('.amp-cart__cart-line')[index];
  return byIndex || null;
}

// Snapshots for reduce-only quantity sync
let AJP_PREV_QTY_BY_KEY = null;                 // { [lineKey]: quantity }
let AJP_PREV_PARENTS_BY_CHILD_KEY = null;       // { [childKey]: string[] } (parent keys)

/** Build current quantity snapshot by line key */
function snapshotQtyByKey(cart) {
  const map = {};
  cart.items.forEach(i => { map[i.key] = i.quantity || 0; });
  return map;
}

/** Build current parent-keys-per-child snapshot from DOM */
function snapshotParentsByChildKey(cart) {
  const map = {};
  document.querySelectorAll('.amp-cart__cart-line.ajp-apo-child').forEach(lineEl => {
    const childKey = lineEl.getAttribute('data-ajp-cart-key');
    const parents  = (lineEl.getAttribute('data-ajp-added-by') || '')
      .split(',').map(s => s.trim()).filter(Boolean);
    if (childKey) map[childKey] = parents;
  });
  return map;
}

/** Update both snapshots after a stable render */
function ajpUpdateSnapshots(cart) {
  AJP_PREV_QTY_BY_KEY = snapshotQtyByKey(cart);
  AJP_PREV_PARENTS_BY_CHILD_KEY = snapshotParentsByChildKey(cart);
}

// Re-tag each rendered line based on its own cart key (ground truth)
function normalizeLineRoles(cart) {
  document.querySelectorAll('.amp-cart__cart-line').forEach(line => {
    const key = line.getAttribute('data-ajp-cart-key');
    if (!key) return;

    const item = cart.items.find(i => i.key === key);
    if (!item) return;

    // Reset and re-apply roles strictly from cart data
    line.classList.remove('ajp-apo-child', 'ajp-apo-parent');

    if (item.properties?.[PROP_KEY_HAS_APO]) {
      line.classList.add('ajp-apo-parent');
    }
    if (item.product_type === PRODUCT_TYPE_TO_HIDE) {
      line.classList.add('ajp-apo-child');
    }

    // Safety: parents should never carry a child link
    if (item.product_type !== PRODUCT_TYPE_TO_HIDE) {
      line.removeAttribute('data-ajp-added-by');
    }
  });
}

// =========================
// Main Functions
// =========================

function stampCartLineData(cart) {
  const cartLines = document.querySelectorAll('.amp-cart__cart-line');

  // 🔄 Clear stale classes/links ONCE per run (not inside the loop)
  document.querySelectorAll('.amp-cart__cart-line').forEach(el => {
    el.classList.remove('ajp-apo-child', 'ajp-apo-parent');
    el.removeAttribute('data-ajp-added-by');
  });

  // 1) First pass: stamp IDs/keys + tag parent/child + apo-link (if present)
  cart.items.forEach((item, index) => {
    const line = getLineElForItem(item, index);
    if (!line) return;

    // Tag roles (mutually exclusive)
    if (item.properties?.[PROP_KEY_HAS_APO]) line.classList.add('ajp-apo-parent');
    if (item.product_type === PRODUCT_TYPE_TO_HIDE) line.classList.add('ajp-apo-child');

    // Always stamp IDs/keys
    line.setAttribute('data-ajp-variant-id', item.variant_id);
    line.setAttribute('data-ajp-cart-key', item.key);

    // Optional: keep apo-link visible in DOM attrs for debugging
    if (item.properties && typeof item.properties === 'object' && item.properties['apo-link']) {
      line.setAttribute('data-ajp-apo-link', item.properties['apo-link']);
    }
  });

  // 2) Second pass: link children → ALL parents (store comma-separated parent keys)
  cart.items.forEach((childItem, childIndex) => {
    // HARD GUARD: only process APO child items
    if (childItem.product_type !== PRODUCT_TYPE_TO_HIDE) return;

    const childLine = getLineElForItem(childItem, childIndex);
    if (!childLine) return;

    const parentKeys = new Set();

    // Primary: apo-link (single parent by variant_id)
    const parentVariantId = childItem.properties?.['apo-link'];
    if (parentVariantId) {
      const p = cart.items.find(i => String(i.variant_id) === String(parentVariantId));
      if (p) parentKeys.add(p.key);
    }

    // Fallback: any parent whose _apo_variants mentions this child's variant id
    const childIdStr = String(childItem.variant_id);
    cart.items.forEach(p => {
      const raw = p.properties?.[PROP_KEY_HAS_APO];
      if (!raw) return;
      const ids = String(raw).match(/\d{8,}/g) || []; // extract numeric IDs
      if (ids.includes(childIdStr)) parentKeys.add(p.key);
    });

    if (parentKeys.size) {
      const keysStr = Array.from(parentKeys).join(',');
      childLine.setAttribute('data-ajp-added-by', keysStr);
      childLine.classList.add('ajp-apo-child'); // keep tagging consistent

      // Consolidated debug log: list all parent variant IDs
      const parents = Array.from(parentKeys)
        .map(k => cart.items.find(i => i.key === k))
        .filter(Boolean);
      const parentIds = parents.map(i => i.variant_id).join(' • ');
      console.log(
        `🔗 APO link established: ${parentIds} (Parent) --> ${childItem.variant_id} (Child) | Parent keys: ${keysStr}`
      );
    } else if (parentVariantId || childItem.properties?.[PROP_KEY_ADDED_BY]) {
      console.warn(`⚠️ Failed to establish APO link for child variant ${childItem.variant_id} – no matching parent found`);
    }
  });
}

function injectOrderedWithLabels(cart) {
  // Only operate on rendered APO child lines; no index mapping at all
  const childLines = document.querySelectorAll('.amp-cart__cart-line.ajp-apo-child');

  childLines.forEach(line => {
    const parentKeysAttr = line.getAttribute('data-ajp-added-by');
    if (!parentKeysAttr) return; // not linked yet

    const targetList =
      line.querySelector('.amp-cart__cart-line-properties') ||
      line.querySelector('.amp-cart__line-properties') ||
      line.querySelector('.cart-line-properties') ||
      line.querySelector('dl');
    if (!targetList) return;

    // Resolve parent titles from the *current* cart by key
    const parentKeys = parentKeysAttr.split(',').map(s => s.trim()).filter(Boolean);
    const parentTitles = parentKeys
      .map(k => cart.items.find(i => i.key === k)?.product_title)
      .filter(Boolean);

    if (!parentTitles.length) return;

    const label = parentTitles.join(' • ');

    // Find or create the row; update if needed
    let row = line.querySelector('.amp-cart__cart-line-properties-item[data-ajp-apo-link]');
    if (!row) {
      row = document.createElement('div');
      row.className = 'amp-cart__cart-line-properties-item';
      row.setAttribute('data-ajp-apo-link', 'true');

      const key = document.createElement('div');
      key.className = 'amp-cart__cart-line-properties-item-key';
      key.innerHTML = 'Ordered With<span>:</span>';

      const value = document.createElement('div');
      value.className = 'amp-cart__cart-line-properties-item-value';
      value.innerText = label;

      row.appendChild(key);
      row.appendChild(value);
      targetList.appendChild(row);
      console.log(`✅ Injected Ordered With (multi): ${label}`);
    } else {
      const value = row.querySelector('.amp-cart__cart-line-properties-item-value');
      if (value && value.innerText !== label) value.innerText = label;
    }
  });

  // Optional sanity check: if any *parent* line somehow has the child class, log it
  document.querySelectorAll('.amp-cart__cart-line.ajp-apo-parent.ajp-apo-child').forEach(el => {
    const key = el.getAttribute('data-ajp-cart-key');
    console.warn('⚠️ Parent line also has ajp-apo-child class (unexpected):', key);
  });
}

async function reduceApoQtyOnParentDecrease(cart) {
  // First run? just take a snapshot; nothing to reduce yet.
  if (!AJP_PREV_QTY_BY_KEY || !AJP_PREV_PARENTS_BY_CHILD_KEY) {
    ajpUpdateSnapshots(cart);
    return;
  }

  const CUR_QTY_BY_KEY = snapshotQtyByKey(cart);
  const changes = [];

  // Iterate rendered APO child lines (DOM-driven to avoid index drift)
  document.querySelectorAll('.amp-cart__cart-line.ajp-apo-child').forEach(lineEl => {
    const childKey = lineEl.getAttribute('data-ajp-cart-key');
    const childItem = cart.items.find(i => i.key === childKey);
    if (!childItem) return;

    // Current parents (from DOM today)
    const curParents = (lineEl.getAttribute('data-ajp-added-by') || '')
      .split(',').map(s => s.trim()).filter(Boolean);

    // Previous parents (from last snapshot)
    const prevParents = (AJP_PREV_PARENTS_BY_CHILD_KEY[childKey] || []).slice();

    // Consider the union so we catch parents that disappeared completely
    const allParents = Array.from(new Set([...prevParents, ...curParents]));

    // Sum only decreases across all linked parents
    let totalDecrease = 0;
    allParents.forEach(pk => {
      const prevQ = AJP_PREV_QTY_BY_KEY[pk] || 0;            // was
      const curQ  = CUR_QTY_BY_KEY[pk] ?? 0;                 // now (0 if parent removed)
      if (curQ < prevQ) totalDecrease += (prevQ - curQ);
    });

    if (totalDecrease <= 0) return; // nothing to reduce

    const newChildQty = Math.max(0, (childItem.quantity || 0) - totalDecrease);
    if (newChildQty === childItem.quantity) return;

    console.log(`↘️ Reduce APO qty: child ${childItem.variant_id} ${childItem.quantity} → ${newChildQty} (parent decrease = ${totalDecrease})`);

    changes.push(
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: childItem.key, quantity: newChildQty })
      }).catch(err => console.warn('APO qty reduce failed:', err))
    );
  });

  if (changes.length) {
    try { await Promise.all(changes); } catch (_) {}
  }

  // Update snapshots for the next update cycle
  ajpUpdateSnapshots(cart);
}

function hideInternalApoRows() {
  const lines = document.querySelectorAll('.amp-cart__cart-line');

  lines.forEach(line => {
    // Hide any "apo-link" property row (internal only)
    line.querySelectorAll('.amp-cart__cart-line-properties-item').forEach(row => {
      const keyEl = row.querySelector('.amp-cart__cart-line-properties-item-key');
      const keyTxt = keyEl?.textContent?.trim().toLowerCase();
      if (keyTxt && keyTxt.startsWith('apo-link')) {
        row.style.display = 'none';
      }
    });

    // On APO child lines, hide default "Title: Yes" variant row
    if (line.classList.contains('ajp-apo-child')) {
      line.querySelectorAll('.amp-cart__cart-line-variant-details-item').forEach(vrow => {
        const k = vrow.querySelector('.amp-cart__cart-line-variant-details-item-key');
        const kTxt = k?.textContent?.toLowerCase().trim().replace(/[:\s]+$/g, '');
        if (kTxt === 'title') {
          vrow.style.display = 'none';
        }
      });
      // Disable clicks on product name
      const titleEl = line.querySelector('.amp-cart__cart-line-title');
      if (titleEl) {
        titleEl.style.pointerEvents = 'none';
        titleEl.style.cursor = 'default';
      }
    }
  });
}

function lockApoChildQuantity() {
  document.querySelectorAll('.amp-cart__cart-line.ajp-apo-child').forEach(line => {
    if (line.classList.contains('ajp-qty-locked')) return;

    const qs = line.querySelector('.amp-cart__line-quantity-selector');
    if (!qs) return;

    const minus = qs.querySelector('.amp-cart__line-quantity-selector-less');
    const plus  = qs.querySelector('.amp-cart__line-quantity-selector-more');
    const input = qs.querySelector('.amp-cart__line-quantity-selector-input');

    [minus, plus].forEach(btn => {
      if (!btn) return;
      btn.setAttribute('disabled', 'disabled');
      btn.setAttribute('aria-disabled', 'true');
      //btn.style.pointerEvents = 'none';
      btn.style.cursor = 'not-allowed';
      btn.classList.add('ajp-disabled');
    });

    if (input) {
      input.setAttribute('readonly', 'readonly');
      input.style.pointerEvents = 'none';
      input.classList.add('ajp-readonly');
      // Optional: block wheel/keyboard changes
      input.addEventListener('keydown', e => e.preventDefault(), { passive: false });
      input.addEventListener('wheel',  e => e.preventDefault(), { passive: false });
    }

    line.classList.add('ajp-qty-locked');
  });
}

/**
 * Fetches the current Shopify cart as JSON from /cart.js.
 * Logs the full list of cart line items to the console for debugging.
 * Returns the complete cart object on success, or null on error.
 * 
 * Usage:
 *   const cart = await fetchCart();
 *   // cart.items will contain all products currently in the cart
 */
async function fetchCart() {
  try {
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });

    if (!response.ok) {
      throw new Error(`Error fetching cart: ${response.statusText}`);
    }

    const cart = await response.json();
    console.log('📦 Full Cart Items:', cart.items);
    return cart;
    
  } catch (error) {
    console.error('❌ Failed to fetch cart:', error);
    return null;
  }
}


// =========================
// Cart States
// =========================

window.AMP_CART_LOADED = function (cart) {
  ampAddClearCartLink();
  ampToggleClearCartLink(cart.item_count);

  requestAnimationFrame(function wait() {
    const lines = document.querySelectorAll('.amp-cart__cart-line');
    if (lines.length >= cart.items.length) {
      stampCartLineData(cart);
      normalizeLineRoles(cart);
      injectOrderedWithLabels(cart);
      hideInternalApoRows();
      lockApoChildQuantity();
    } else {
      requestAnimationFrame(wait);
    }
  });
};

window.AMP_CART_UPDATED = function (cart) {
  ampAddClearCartLink();
  ampToggleClearCartLink(cart.item_count);

  requestAnimationFrame(function wait() {
    const lines = document.querySelectorAll('.amp-cart__cart-line');
    if (lines.length >= cart.items.length) {
      stampCartLineData(cart);
      normalizeLineRoles(cart);
      injectOrderedWithLabels(cart);
      hideInternalApoRows();
      lockApoChildQuantity();

      // reduce-only sync (decreases/removals)
      reduceApoQtyOnParentDecrease(cart);  // ← uses previous snapshots
      // refresh snapshots for next run
      ajpUpdateSnapshots(cart);
    } else {
      requestAnimationFrame(wait);
    }
  });
};

window.AMP_CART_OPENED = function () {
  console.log('🚪 AMP_CART_OPENED triggered');
  (async () => {
    try {
      const fetchedCart = await fetchCart();
      if (!fetchedCart) return;

      ampAddClearCartLink();
      ampToggleClearCartLink(fetchedCart.item_count);

      const waitForCartRender = () => {
        const allRendered = [...document.querySelectorAll('.amp-cart__cart-line')].length >= fetchedCart.items.length;
        if (allRendered) {
          stampCartLineData(fetchedCart);
          normalizeLineRoles(fetchedCart);
          injectOrderedWithLabels(fetchedCart);
          hideInternalApoRows();
          lockApoChildQuantity();
        } else {
          requestAnimationFrame(waitForCartRender);
        }
      };
      waitForCartRender();
    } catch (e) {
      console.error('❌ AMP_CART_OPENED error:', e);
    }
  })();
};

// GJ20251030 — AMP Upsells ⇆ Dawn spinner bridge (scoped + instrumented)
(function(){
  const BTN_SEL      = 'product-form [type="submit"], product-form button[name="add"]';
  const SPINNER_SEL  = '.loading__spinner';

  let lastAtcBtn = null; // the specific button the user clicked

  function showSpinnerFor(btn){
    if (!btn) return;
    const sp = btn.querySelector(SPINNER_SEL);
    if (!sp) { console.warn('[AJP AMP] No spinner found in button', btn); return; }

    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('loading','is-loading');
    sp.classList.remove('hidden');
    //console.log('[AJP AMP] showSpinnerFor → ON', btn);
  }

  function hideSpinnerFor(btn, reason){
    if (!btn) return;
    const sp = btn.querySelector(SPINNER_SEL);
    if (!sp) return;

    // small delay so it’s actually visible to humans if AMP is super fast
    setTimeout(() => {
      sp.classList.add('hidden');
      btn.classList.remove('loading','is-loading');
      btn.removeAttribute('aria-disabled');
      //console.log('[AJP AMP] hideSpinnerFor → OFF (' + reason + ')', btn);
    }, 200);
  }

  // 1) Capture the exact ATC button the user clicks inside a <product-form>
  document.addEventListener('click', (e) => {
    const btn = e.target.closest(BTN_SEL);
    if (!btn || !btn.closest('product-form')) return;
    lastAtcBtn = btn;
    //console.log('[AJP AMP] ATC click captured on', lastAtcBtn);
    showSpinnerFor(lastAtcBtn);
  }, true); // capture to run before AMP

  // 2) When AMP reports updated/opened, hide spinner on that same button
  const prevUpdated = window.AMP_CART_UPDATED;
  window.AMP_CART_UPDATED = function(cart){
    if (lastAtcBtn) hideSpinnerFor(lastAtcBtn, 'AMP_CART_UPDATED');
    if (typeof prevUpdated === 'function') prevUpdated(cart);
  };

  const prevOpened = window.AMP_CART_OPENED;
  window.AMP_CART_OPENED = function(){
    if (lastAtcBtn) hideSpinnerFor(lastAtcBtn, 'AMP_CART_OPENED');
    if (typeof prevOpened === 'function') prevOpened();
  };

  // 3) Safety: if AMP neither opens nor updates (rare), hide after 8s
  setInterval(() => {
    if (!lastAtcBtn) return;
    const sp = lastAtcBtn.querySelector(SPINNER_SEL);
    if (sp && !sp.classList.contains('hidden')) {
      hideSpinnerFor(lastAtcBtn, 'safety-timeout');
    }
  }, 8000);
})();

// GJ — AMP Upsells cart drawer bridge (open + close)
(function(){
  const ROOT_SEL   = '.amp-cart';
  const OPEN_CLASS = 'amp-cart--open';
  const CLOSE_SEL  = '.amp-cart__header-close-button, .amp-cart-drawer__overlay';
  const ATC_BTN_SEL = 'product-form [type="submit"], product-form button[name="add"]';

  // Track last add-to-cart click
  let atcPending = false;
  document.addEventListener('click', e => {
    const btn = e.target.closest(ATC_BTN_SEL);
    if (btn) atcPending = true;
  }, true);

  // Open drawer when AMP updates the cart
  const prevUpdated = window.AMP_CART_UPDATED;
  window.AMP_CART_UPDATED = function(cart){
    if (typeof prevUpdated === 'function') prevUpdated(cart);

    // open only after an ATC click
    if (!atcPending) return;
    atcPending = false;

    const root = document.querySelector(ROOT_SEL);
    if (!root) return;

    try { window.AMP?.openCart?.(); } catch(_) {}
    root.classList.add(OPEN_CLASS);
    console.log('[AJP AMP] forced drawer open (AMP_CART_UPDATED)');
  };

  // Manual close (header X or overlay)
  document.addEventListener('click', e => {
    const hit = e.target.closest(CLOSE_SEL);
    if (!hit) return;
    const root = document.querySelector(ROOT_SEL);
    if (root) {
      root.classList.remove(OPEN_CLASS);
      console.log('[AJP AMP] force-close triggered');
    }
  }, true);
})();

// GJ — Directly update header cart bubble using AMP cart data
(function(){
  const BUBBLE_SEL = '#cart-icon-bubble .cart-count-bubble';
  const COUNT_SEL  = '[aria-hidden="true"]';
  const TEXT_SEL   = '.visually-hidden';

  function updateBubbleFromCart(cart){
    if (!cart || typeof cart.item_count !== 'number') return;

    document.querySelectorAll(BUBBLE_SEL).forEach(bubble => {
      const count = cart.item_count;
      // remove badge completely if empty
      if (count <= 0) {
        bubble.remove();
        return;
      }

      // ensure badge exists
      let hiddenNum = bubble.querySelector(COUNT_SEL);
      let visText   = bubble.querySelector(TEXT_SEL);
      
      if (!hiddenNum) {
        hiddenNum = document.createElement('span');
        hiddenNum.setAttribute('aria-hidden','true');
        bubble.appendChild(hiddenNum);
      }
      if (!visText) {
        visText = document.createElement('span');
        visText.className = 'visually-hidden';
        bubble.appendChild(visText);
      }

      hiddenNum.textContent = count;
      visText.textContent   = count === 1 ? '1 item' : `${count} items`;
    });
  }

  // Hook into AMP’s own update event
  const prev = window.AMP_CART_UPDATED;
  window.AMP_CART_UPDATED = function(cart){
    updateBubbleFromCart(cart);
    if (typeof prev === 'function') return prev.apply(this, arguments);
  };
})();
